import React, { Component } from 'react';
import classnames from 'classnames';
import './index.scss';
import Preview from '../Preview';

import Close from '../../../../assets/images/Close.png'
import Open from '../../../../assets/images/Open.png'

class Design extends Component {
  
    constructor(props){
      super(props);
      this.state ={
        selected:(props.props.collapse_on_start)?'Close':'Open',
        imageSrc:(props.props.collapse_on_start)?Close:Open
      }
    }

    changeSetting = (values) =>{
      this.setState({
        selected:values,
        imageSrc:this.getImageForState(values)
      })
      console.log('values',values)
    }

    onSave = ()=>{
      this.props.onValueChange({target:{value:(this.state.selected==='Open')?false:true}},"collapse_on_start")
    }

    getImageForState = (value) =>{
      if(value === 'Close'){
        return Close;
      }else{
        return Open;
      }
    }
    onCancelClick =()=>{
      this.props.onCancel();
      setTimeout(()=>{
        this.setState({
          selected:(this.props.props.collapse_on_start)?'Close':'Open',
          imageSrc:(this.props.props.collapse_on_start)?Close:Open
        })
      },100);
    }

    render(){
      const {selected}=this.state;
      const {props ,onValueChange} = this.props;
      return (<div className="init">
                <div className="intit-container">
                <div className="design-config">
                    <div className="selection">
                      <div className="radio-section">
                        <div className="radio-group" onClick={()=>this.changeSetting('Open')}>
                            <div className="radio-outer">
                                <div className={classnames({'radio-inner':selected==='Open'})}> </div>
                            </div>
                            <div className="disp-value">Open</div>
                        </div>
                        <div className="description">Chat window will be fully open when the page loads, regardless of whether the visitor needs help or not. 
                        Keep in mind that this approach can be irritating for visitors and produce results opposite to what was intended.</div>
                      </div>
                      <div className="radio-section">
                          <div className="radio-group" onClick={()=>this.changeSetting('Close')}>
                              <div className="radio-outer">
                                <div className={classnames({'radio-inner':selected==='Close'})}> </div>
                              </div>
                              <div className="disp-value">Closed</div>
                          </div>
                          <div className="description">Chat window will open fully, only when visitors need help.</div>
                      </div>
                    </div>
                </div>
                <div className="sample-view">
                  <img className="image" src={this.state.imageSrc}/>
                </div>
                </div>
                <div className="action-area">
                      <div>
                          <button type="button" className="btn btn--primary btn--md first-button" onClick={(e)=>this.onSave()}>
                              SAVE
                          </button>
                          <button type="button" className="btn btn--link button-cancel" onClick={this.onCancelClick}>
                              Cancel
                          </button>
                      </div>
                    </div>
              </div>)
    }
};

export default Design;
